export const TRANSLATIONS = {
      en: {
        "Accessibility": "Accessibility",
        "Accessibility Options": "Accessibility Options",
        "Accessibility Menu": "Accessibility Menu",
        "Reset settings": "Reset settings",
        "Reset All Settings": "Reset All Settings",
        "Close": "Close",
        "Content Adjustments": "Content Adjustments",
        "Adjust Font Size": "Adjust Font Size",
        "Highlight Title": "Highlight Title",
        "Highlight Links": "Highlight Links",
        "Readable Font": "Readable Font",
        "Color Adjustments": "Color Adjustments",
        "Invert Colors": "Invert Colors",
        "Light Contrast": "Light Contrast",
        "Dark Contrast": "Dark Contrast",
        "High Contrast": "High Contrast",
        "High Saturation": "High Saturation",
        "Low Saturation": "Low Saturation",
        "Monochrome": "Monochrome",
        "Tools": "Tools",
        "Reading Guide": "Reading Guide",
        "Stop Animations": "Stop Animations",
        "Big Cursor": "Big Cursor",
        "Increase Font Size": "Increase Font Size",
        "Decrease Font Size": "Decrease Font Size",
        "Letter Spacing": "Letter Spacing",
        "Line Height": "Line Height",
        "Font Weight": "Font Weight",
        "Dyslexia Font": "Dyslexia Font",
        "Font Size": "Font Size",
        "Language": "Language",
        "All Languages": "All Languages",
        "Search language": "Search language",
        "Open Accessibility Menu": "Open Accessibility Menu",
        "Open accessibility menu": "Open accessibility menu",
        "Hide Images": "Hide Images",
        "Skip to accessibility menu": "Skip to accessibility menu",
        "Accessibility Report": "Accessibility Report",
        "Run Accessibility Check": "Run Accessibility Check",
        "Loading...": "Loading...",
        "Analyzing page...": "Analyzing page...",
        "Critical": "Critical",
        "Serious": "Serious",
        "Moderate": "Moderate",
        "Minor": "Minor",
        "Violations Found": "Violations Found",
        "No Issues Found": "No Issues Found",
        "Element": "Element",
        "Issue": "Issue",
        "How to Fix": "How to Fix",
        "Close Report": "Close Report",
        "Passed Tests": "Passed Tests",
        "Items Need Review": "Items Need Review",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Text to Speech On",
        "Text to Speech Off": "Text to Speech Off",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Speech",
        "Text": "Text",
        "Color & Contrast": "Color & Contrast",
        "Reading Aids": "Reading Aids",
        "Interaction": "Interaction",
        "Contrast": "Contrast",
        "Saturation": "Saturation",
        "Light": "Light",
        "Dark": "Dark",
        "High": "High",
        "Low": "Low",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Loading voice...",
        "Reading...": "Reading...",
        "Profiles": "Profiles",
        "Seizure Safe": "Seizure Safe",
        "Vision Impaired": "Vision Impaired",
        "ADHD Friendly": "ADHD Friendly",
        "Dyslexia Friendly": "Dyslexia Friendly",
        "On": "On",
        "Off": "Off",
        "Mute Sounds": "Mute Sounds",
        "Page Structure": "Page Structure",
        "Text Magnifier": "Text Magnifier",
        "Headings": "Headings",
        "Landmarks": "Landmarks",
        "Links": "Links",
        "No items found": "No items found",
        "Settings reset": "Settings reset",
      },
      pt: {
        "Accessibility": "Acessibilidade",
        "Accessibility Options": "Opções de acessibilidade",
        "Accessibility Menu": "Menu de Acessibilidade",
        "Reset settings": "Redefinir configurações",
        "Reset All Settings": "Redefinir todas as configurações",
        "Close": "Fechar",
        "Content Adjustments": "Ajustes de Conteúdo",
        "Adjust Font Size": "Ajustar Tamanho da Fonte",
        "Highlight Title": "Destacar Títulos",
        "Highlight Links": "Destacar Links",
        "Readable Font": "Fonte Legível",
        "Color Adjustments": "Ajustes de Cor",
        "Invert Colors": "Inverter Cores",
        "Light Contrast": "Contraste Claro",
        "Dark Contrast": "Contraste Escuro",
        "High Contrast": "Alto Contraste",
        "High Saturation": "Alta Saturação",
        "Low Saturation": "Baixa Saturação",
        "Monochrome": "Monocromático",
        "Tools": "Ferramentas",
        "Reading Guide": "Guia de Leitura",
        "Stop Animations": "Parar Animações",
        "Big Cursor": "Cursor Grande",
        "Increase Font Size": "Aumentar Tamanho da Fonte",
        "Decrease Font Size": "Diminuir Tamanho da Fonte",
        "Letter Spacing": "Espaçamento entre Letras",
        "Line Height": "Altura da Linha",
        "Font Weight": "Peso da Fonte",
        "Dyslexia Font": "Fonte para Dislexia",
        "Font Size": "Tamanho da Fonte",
        "Language": "Idioma",
        "All Languages": "Todos os Idiomas",
        "Search language": "Buscar idioma",
        "Open Accessibility Menu": "Abrir Menu de Acessibilidade",
        "Open accessibility menu": "Abrir menu de acessibilidade",
        "Hide Images": "Ocultar Imagens",
        "Skip to accessibility menu": "Ir para o menu de acessibilidade",
        "Accessibility Report": "Relatório de Acessibilidade",
        "Run Accessibility Check": "Executar Verificação de Acessibilidade",
        "Loading...": "Carregando...",
        "Analyzing page...": "Analisando página...",
        "Critical": "Crítico",
        "Serious": "Sério",
        "Moderate": "Moderado",
        "Minor": "Leve",
        "Violations Found": "Violações Encontradas",
        "No Issues Found": "Nenhum Problema Encontrado",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Como Corrigir",
        "Close Report": "Fechar Relatório",
        "Passed Tests": "Testes Aprovados",
        "Items Need Review": "Itens Precisam de Revisão",
        "Annotations": "Anotações",
        "Text to Speech": "Texto para Fala",
        "Text to Speech On": "Texto para Fala Ativado",
        "Text to Speech Off": "Texto para Fala Desativado",
        "Simplify Layout": "Simplificar Layout",
        "Speech": "Fala",
        "Text": "Texto",
        "Color & Contrast": "Cor e Contraste",
        "Reading Aids": "Ajudas de Leitura",
        "Interaction": "Interação",
        "Contrast": "Contraste",
        "Saturation": "Saturação",
        "Light": "Claro",
        "Dark": "Escuro",
        "High": "Alto",
        "Low": "Baixo",
        "Play": "Reproduzir",
        "Pause": "Pausar",
        "Stop": "Parar",
        "Loading voice...": "Carregando voz...",
        "Reading...": "Lendo...",
        "Profiles": "Perfis",
        "Seizure Safe": "Seguro para Epilepsia",
        "Vision Impaired": "Deficiência Visual",
        "ADHD Friendly": "Adaptado para TDAH",
        "Dyslexia Friendly": "Adaptado para Dislexia",
        "On": "Ativado",
        "Off": "Desativado",
        "Mute Sounds": "Silenciar Sons",
        "Page Structure": "Estrutura da Página",
        "Text Magnifier": "Lupa de Texto",
        "Headings": "Títulos",
        "Landmarks": "Pontos de Referência",
        "Links": "Links",
        "No items found": "Nenhum item encontrado",
        "Settings reset": "Configurações redefinidas",
      },
      it: {
        "Accessibility": "Accessibilità",
        "Accessibility Options": "Opzioni di accessibilità",
        "Accessibility Menu": "Menu Accessibilità",
        "Reset settings": "Ripristina impostazioni",
        "Reset All Settings": "Ripristina tutte le impostazioni",
        "Close": "Chiudi",
        "Content Adjustments": "Regolazioni Contenuto",
        "Adjust Font Size": "Regola Dimensione Font",
        "Highlight Title": "Evidenzia Titoli",
        "Highlight Links": "Evidenzia Link",
        "Readable Font": "Font Leggibile",
        "Color Adjustments": "Regolazioni Colore",
        "Invert Colors": "Inverti Colori",
        "Light Contrast": "Contrasto Chiaro",
        "Dark Contrast": "Contrasto Scuro",
        "High Contrast": "Alto Contrasto",
        "High Saturation": "Alta Saturazione",
        "Low Saturation": "Bassa Saturazione",
        "Monochrome": "Monocromatico",
        "Tools": "Strumenti",
        "Reading Guide": "Guida di Lettura",
        "Stop Animations": "Ferma Animazioni",
        "Big Cursor": "Cursore Grande",
        "Increase Font Size": "Aumenta Dimensione Font",
        "Decrease Font Size": "Diminuisci Dimensione Font",
        "Letter Spacing": "Spaziatura Lettere",
        "Line Height": "Altezza Riga",
        "Font Weight": "Grassetto",
        "Dyslexia Font": "Font Dislessia",
        "Font Size": "Dimensione Font",
        "Language": "Lingua",
        "All Languages": "Tutte le Lingue",
        "Search language": "Cerca lingua",
        "Open Accessibility Menu": "Apri Menu Accessibilità",
        "Open accessibility menu": "Apri menu accessibilità",
        "Hide Images": "Nascondi Immagini",
        "Skip to accessibility menu": "Vai al menu accessibilità",
        "Accessibility Report": "Report Accessibilità",
        "Run Accessibility Check": "Esegui Controllo Accessibilità",
        "Loading...": "Caricamento...",
        "Analyzing page...": "Analisi pagina...",
        "Critical": "Critico",
        "Serious": "Grave",
        "Moderate": "Moderato",
        "Minor": "Minore",
        "Violations Found": "Violazioni Trovate",
        "No Issues Found": "Nessun Problema Trovato",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Come Risolvere",
        "Close Report": "Chiudi Report",
        "Passed Tests": "Test Superati",
        "Items Need Review": "Elementi da Rivedere",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Sintesi Vocale Attiva",
        "Text to Speech Off": "Sintesi Vocale Disattiva",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voce",
        "Text": "Testo",
        "Color & Contrast": "Colore e Contrasto",
        "Reading Aids": "Aiuti alla Lettura",
        "Interaction": "Interazione",
        "Contrast": "Contrasto",
        "Saturation": "Saturazione",
        "Light": "Chiaro",
        "Dark": "Scuro",
        "High": "Alta",
        "Low": "Bassa",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Caricamento voce...",
        "Reading...": "Reading...",
        "Profiles": "Profili",
        "Seizure Safe": "Sicuro per Epilessia",
        "Vision Impaired": "Ipovisione",
        "ADHD Friendly": "Adatto per ADHD",
        "Dyslexia Friendly": "Adatto per Dislessia",
        "On": "Attivato",
        "Off": "Disattivato",
        "Mute Sounds": "Disattiva Suoni",
        "Page Structure": "Struttura della Pagina",
        "Text Magnifier": "Lente d'Ingrandimento Testo",
        "Headings": "Intestazioni",
        "Landmarks": "Punti di Riferimento",
        "Links": "Link",
        "No items found": "Nessun elemento trovato",
        "Settings reset": "Impostazioni ripristinate",
      },
      fr: {
        "Accessibility": "Accessibilité",
        "Accessibility Options": "Options d'accessibilité",
        "Accessibility Menu": "Menu Accessibilité",
        "Reset settings": "Réinitialiser les paramètres",
        "Reset All Settings": "Réinitialiser tous les paramètres",
        "Close": "Fermer",
        "Content Adjustments": "Ajustements du Contenu",
        "Adjust Font Size": "Ajuster la Taille de Police",
        "Highlight Title": "Surligner les Titres",
        "Highlight Links": "Surligner les Liens",
        "Readable Font": "Police Lisible",
        "Color Adjustments": "Ajustements des Couleurs",
        "Invert Colors": "Inverser les Couleurs",
        "Light Contrast": "Contraste Clair",
        "Dark Contrast": "Contraste Sombre",
        "High Contrast": "Contraste Élevé",
        "High Saturation": "Saturation Élevée",
        "Low Saturation": "Saturation Faible",
        "Monochrome": "Monochrome",
        "Tools": "Outils",
        "Reading Guide": "Guide de Lecture",
        "Stop Animations": "Arrêter les Animations",
        "Big Cursor": "Grand Curseur",
        "Increase Font Size": "Augmenter la Taille de Police",
        "Decrease Font Size": "Diminuer la Taille de Police",
        "Letter Spacing": "Espacement des Lettres",
        "Line Height": "Hauteur de Ligne",
        "Font Weight": "Graisse de Police",
        "Dyslexia Font": "Police Dyslexie",
        "Font Size": "Taille de Police",
        "Language": "Langue",
        "All Languages": "Toutes les Langues",
        "Search language": "Rechercher une langue",
        "Open Accessibility Menu": "Ouvrir le Menu Accessibilité",
        "Open accessibility menu": "Ouvrir le menu accessibilité",
        "Hide Images": "Masquer les Images",
        "Skip to accessibility menu": "Aller au menu accessibilité",
        "Accessibility Report": "Rapport d'Accessibilité",
        "Run Accessibility Check": "Lancer le Contrôle d'Accessibilité",
        "Loading...": "Chargement...",
        "Analyzing page...": "Analyse de la page...",
        "Critical": "Critique",
        "Serious": "Grave",
        "Moderate": "Modéré",
        "Minor": "Mineur",
        "Violations Found": "Violations Trouvées",
        "No Issues Found": "Aucun Problème Trouvé",
        "Element": "Élément",
        "Issue": "Problème",
        "How to Fix": "Comment Corriger",
        "Close Report": "Fermer le Rapport",
        "Passed Tests": "Tests Réussis",
        "Items Need Review": "Éléments à Vérifier",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Synthèse Vocale Activée",
        "Text to Speech Off": "Synthèse Vocale Désactivée",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voix",
        "Text": "Texte",
        "Color & Contrast": "Couleur et Contraste",
        "Reading Aids": "Aides à la Lecture",
        "Interaction": "Interaction",
        "Contrast": "Contraste",
        "Saturation": "Saturation",
        "Light": "Clair",
        "Dark": "Sombre",
        "High": "Élevée",
        "Low": "Faible",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Chargement de la voix...",
        "Reading...": "Reading...",
        "Profiles": "Profils",
        "Seizure Safe": "Protection Épilepsie",
        "Vision Impaired": "Déficience Visuelle",
        "ADHD Friendly": "Adapté TDAH",
        "Dyslexia Friendly": "Adapté Dyslexie",
        "On": "Activé",
        "Off": "Désactivé",
        "Mute Sounds": "Couper les Sons",
        "Page Structure": "Structure de la Page",
        "Text Magnifier": "Loupe de Texte",
        "Headings": "Titres",
        "Landmarks": "Points de Repère",
        "Links": "Liens",
        "No items found": "Aucun élément trouvé",
        "Settings reset": "Paramètres réinitialisés",
      },
      de: {
        "Accessibility": "Barrierefreiheit",
        "Accessibility Options": "Optionen für Barrierefreiheit",
        "Accessibility Menu": "Barrierefreiheit-Menü",
        "Reset settings": "Einstellungen zurücksetzen",
        "Reset All Settings": "Alle Einstellungen zurücksetzen",
        "Close": "Schließen",
        "Content Adjustments": "Inhaltsanpassungen",
        "Adjust Font Size": "Schriftgröße anpassen",
        "Highlight Title": "Titel hervorheben",
        "Highlight Links": "Links hervorheben",
        "Readable Font": "Lesbare Schrift",
        "Color Adjustments": "Farbanpassungen",
        "Invert Colors": "Farben invertieren",
        "Light Contrast": "Heller Kontrast",
        "Dark Contrast": "Dunkler Kontrast",
        "High Contrast": "Hoher Kontrast",
        "High Saturation": "Hohe Sättigung",
        "Low Saturation": "Niedrige Sättigung",
        "Monochrome": "Monochrom",
        "Tools": "Werkzeuge",
        "Reading Guide": "Lesehilfe",
        "Stop Animations": "Animationen stoppen",
        "Big Cursor": "Großer Cursor",
        "Increase Font Size": "Schriftgröße erhöhen",
        "Decrease Font Size": "Schriftgröße verringern",
        "Letter Spacing": "Zeichenabstand",
        "Line Height": "Zeilenhöhe",
        "Font Weight": "Schriftstärke",
        "Dyslexia Font": "Legasthenie-Schrift",
        "Font Size": "Schriftgröße",
        "Language": "Sprache",
        "All Languages": "Alle Sprachen",
        "Search language": "Sprache suchen",
        "Open Accessibility Menu": "Barrierefreiheit-Menü öffnen",
        "Open accessibility menu": "Barrierefreiheit-Menü öffnen",
        "Hide Images": "Bilder ausblenden",
        "Skip to accessibility menu": "Zum Barrierefreiheit-Menü springen",
        "Accessibility Report": "Barrierefreiheit-Bericht",
        "Run Accessibility Check": "Barrierefreiheitsprüfung starten",
        "Loading...": "Laden...",
        "Analyzing page...": "Seite wird analysiert...",
        "Critical": "Kritisch",
        "Serious": "Schwerwiegend",
        "Moderate": "Mäßig",
        "Minor": "Gering",
        "Violations Found": "Verstöße gefunden",
        "No Issues Found": "Keine Probleme gefunden",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Lösung",
        "Close Report": "Bericht schließen",
        "Passed Tests": "Bestandene Tests",
        "Items Need Review": "Elemente zur Überprüfung",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Sprachausgabe Ein",
        "Text to Speech Off": "Sprachausgabe Aus",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Sprachausgabe",
        "Text": "Text",
        "Color & Contrast": "Farbe & Kontrast",
        "Reading Aids": "Lesehilfen",
        "Interaction": "Interaktion",
        "Contrast": "Kontrast",
        "Saturation": "Sättigung",
        "Light": "Hell",
        "Dark": "Dunkel",
        "High": "Hoch",
        "Low": "Niedrig",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Stimme wird geladen...",
        "Reading...": "Reading...",
        "Profiles": "Profile",
        "Seizure Safe": "Anfallssicher",
        "Vision Impaired": "Sehbeeinträchtigung",
        "ADHD Friendly": "ADHS-freundlich",
        "Dyslexia Friendly": "Legasthenie-freundlich",
        "On": "Ein",
        "Off": "Aus",
        "Mute Sounds": "Töne stummschalten",
        "Page Structure": "Seitenstruktur",
        "Text Magnifier": "Textlupe",
        "Headings": "Überschriften",
        "Landmarks": "Orientierungspunkte",
        "Links": "Links",
        "No items found": "Keine Einträge gefunden",
        "Settings reset": "Einstellungen zurückgesetzt",
      },
      es: {
        "Accessibility": "Accesibilidad",
        "Accessibility Options": "Opciones de accesibilidad",
        "Accessibility Menu": "Menú de Accesibilidad",
        "Reset settings": "Restablecer configuración",
        "Reset All Settings": "Restablecer toda la configuración",
        "Close": "Cerrar",
        "Content Adjustments": "Ajustes de Contenido",
        "Adjust Font Size": "Ajustar Tamaño de Fuente",
        "Highlight Title": "Resaltar Títulos",
        "Highlight Links": "Resaltar Enlaces",
        "Readable Font": "Fuente Legible",
        "Color Adjustments": "Ajustes de Color",
        "Invert Colors": "Invertir Colores",
        "Light Contrast": "Contraste Claro",
        "Dark Contrast": "Contraste Oscuro",
        "High Contrast": "Alto Contraste",
        "High Saturation": "Alta Saturación",
        "Low Saturation": "Baja Saturación",
        "Monochrome": "Monocromo",
        "Tools": "Herramientas",
        "Reading Guide": "Guía de Lectura",
        "Stop Animations": "Detener Animaciones",
        "Big Cursor": "Cursor Grande",
        "Increase Font Size": "Aumentar Tamaño de Fuente",
        "Decrease Font Size": "Disminuir Tamaño de Fuente",
        "Letter Spacing": "Espaciado de Letras",
        "Line Height": "Altura de Línea",
        "Font Weight": "Grosor de Fuente",
        "Dyslexia Font": "Fuente para Dislexia",
        "Font Size": "Tamaño de Fuente",
        "Language": "Idioma",
        "All Languages": "Todos los Idiomas",
        "Search language": "Buscar idioma",
        "Open Accessibility Menu": "Abrir Menú de Accesibilidad",
        "Open accessibility menu": "Abrir menú de accesibilidad",
        "Hide Images": "Ocultar Imágenes",
        "Skip to accessibility menu": "Ir al menú de accesibilidad",
        "Accessibility Report": "Informe de Accesibilidad",
        "Run Accessibility Check": "Ejecutar Comprobación de Accesibilidad",
        "Loading...": "Cargando...",
        "Analyzing page...": "Analizando página...",
        "Critical": "Crítico",
        "Serious": "Grave",
        "Moderate": "Moderado",
        "Minor": "Menor",
        "Violations Found": "Violaciones Encontradas",
        "No Issues Found": "Sin Problemas Encontrados",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Cómo Solucionarlo",
        "Close Report": "Cerrar Informe",
        "Passed Tests": "Pruebas Superadas",
        "Items Need Review": "Elementos a Revisar",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Texto a Voz Activado",
        "Text to Speech Off": "Texto a Voz Desactivado",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voz",
        "Text": "Texto",
        "Color & Contrast": "Color y Contraste",
        "Reading Aids": "Ayudas de Lectura",
        "Interaction": "Interacción",
        "Contrast": "Contraste",
        "Saturation": "Saturación",
        "Light": "Claro",
        "Dark": "Oscuro",
        "High": "Alta",
        "Low": "Baja",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Cargando voz...",
        "Reading...": "Reading...",
        "Profiles": "Perfiles",
        "Seizure Safe": "Seguro para Epilepsia",
        "Vision Impaired": "Discapacidad Visual",
        "ADHD Friendly": "Adaptado para TDAH",
        "Dyslexia Friendly": "Adaptado para Dislexia",
        "On": "Activado",
        "Off": "Desactivado",
        "Mute Sounds": "Silenciar Sonidos",
        "Page Structure": "Estructura de la Página",
        "Text Magnifier": "Lupa de Texto",
        "Headings": "Encabezados",
        "Landmarks": "Puntos de Referencia",
        "Links": "Enlaces",
        "No items found": "No se encontraron elementos",
        "Settings reset": "Configuración restablecida",
      },
      ru: {
        "Accessibility": "Доступность",
        "Accessibility Options": "Настройки доступности",
        "Accessibility Menu": "Меню доступности",
        "Reset settings": "Сбросить настройки",
        "Reset All Settings": "Сбросить все настройки",
        "Close": "Закрыть",
        "Content Adjustments": "Настройки контента",
        "Adjust Font Size": "Изменить размер шрифта",
        "Highlight Title": "Выделить заголовки",
        "Highlight Links": "Выделить ссылки",
        "Readable Font": "Читаемый шрифт",
        "Color Adjustments": "Настройки цвета",
        "Invert Colors": "Инвертировать цвета",
        "Light Contrast": "Светлый контраст",
        "Dark Contrast": "Тёмный контраст",
        "High Contrast": "Высокий контраст",
        "High Saturation": "Высокая насыщенность",
        "Low Saturation": "Низкая насыщенность",
        "Monochrome": "Монохромный",
        "Tools": "Инструменты",
        "Reading Guide": "Линейка для чтения",
        "Stop Animations": "Остановить анимации",
        "Big Cursor": "Большой курсор",
        "Increase Font Size": "Увеличить размер шрифта",
        "Decrease Font Size": "Уменьшить размер шрифта",
        "Letter Spacing": "Межбуквенный интервал",
        "Line Height": "Высота строки",
        "Font Weight": "Жирный шрифт",
        "Dyslexia Font": "Шрифт для дислексии",
        "Font Size": "Размер шрифта",
        "Language": "Язык",
        "All Languages": "Все языки",
        "Search language": "Поиск языка",
        "Open Accessibility Menu": "Открыть меню доступности",
        "Open accessibility menu": "Открыть меню доступности",
        "Hide Images": "Скрыть изображения",
        "Skip to accessibility menu": "Перейти к меню доступности",
        "Accessibility Report": "Отчёт о доступности",
        "Run Accessibility Check": "Запустить проверку доступности",
        "Loading...": "Загрузка...",
        "Analyzing page...": "Анализ страницы...",
        "Critical": "Критический",
        "Serious": "Серьёзный",
        "Moderate": "Умеренный",
        "Minor": "Незначительный",
        "Violations Found": "Найдены нарушения",
        "No Issues Found": "Проблем не найдено",
        "Element": "Элемент",
        "Issue": "Проблема",
        "How to Fix": "Как исправить",
        "Close Report": "Закрыть отчёт",
        "Passed Tests": "Пройденные тесты",
        "Items Need Review": "Требуют проверки",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Озвучивание Включено",
        "Text to Speech Off": "Озвучивание Выключено",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Речь",
        "Text": "Текст",
        "Color & Contrast": "Цвет и контраст",
        "Reading Aids": "Помощь при чтении",
        "Interaction": "Взаимодействие",
        "Contrast": "Контраст",
        "Saturation": "Насыщенность",
        "Light": "Светлый",
        "Dark": "Тёмный",
        "High": "Высокая",
        "Low": "Низкая",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Загрузка голоса...",
        "Reading...": "Reading...",
        "Profiles": "Профили",
        "Seizure Safe": "Защита от эпилепсии",
        "Vision Impaired": "Для слабовидящих",
        "ADHD Friendly": "Для людей с СДВГ",
        "Dyslexia Friendly": "Для людей с дислексией",
        "On": "Включено",
        "Off": "Выключено",
        "Mute Sounds": "Отключить звук",
        "Page Structure": "Структура страницы",
        "Text Magnifier": "Текстовая лупа",
        "Headings": "Заголовки",
        "Landmarks": "Ориентиры",
        "Links": "Ссылки",
        "No items found": "Ничего не найдено",
        "Settings reset": "Настройки сброшены",
      },
      pl: {
        "Accessibility": "Dostępność",
        "Accessibility Options": "Opcje dostępności",
        "Accessibility Menu": "Menu Dostępności",
        "Reset settings": "Zresetuj ustawienia",
        "Reset All Settings": "Zresetuj wszystkie ustawienia",
        "Close": "Zamknij",
        "Content Adjustments": "Dostosowanie Treści",
        "Adjust Font Size": "Dostosuj Rozmiar Czcionki",
        "Highlight Title": "Podświetl Tytuły",
        "Highlight Links": "Podświetl Linki",
        "Readable Font": "Czytelna Czcionka",
        "Color Adjustments": "Dostosowanie Kolorów",
        "Invert Colors": "Odwróć Kolory",
        "Light Contrast": "Jasny Kontrast",
        "Dark Contrast": "Ciemny Kontrast",
        "High Contrast": "Wysoki Kontrast",
        "High Saturation": "Wysoka Saturacja",
        "Low Saturation": "Niska Saturacja",
        "Monochrome": "Monochromatyczny",
        "Tools": "Narzędzia",
        "Reading Guide": "Linia do Czytania",
        "Stop Animations": "Zatrzymaj Animacje",
        "Big Cursor": "Duży Kursor",
        "Increase Font Size": "Zwiększ Rozmiar Czcionki",
        "Decrease Font Size": "Zmniejsz Rozmiar Czcionki",
        "Letter Spacing": "Odstępy Między Literami",
        "Line Height": "Wysokość Linii",
        "Font Weight": "Grubość Czcionki",
        "Dyslexia Font": "Czcionka dla Dysleksji",
        "Font Size": "Rozmiar Czcionki",
        "Language": "Język",
        "All Languages": "Wszystkie Języki",
        "Search language": "Szukaj języka",
        "Open Accessibility Menu": "Otwórz Menu Dostępności",
        "Open accessibility menu": "Otwórz menu dostępności",
        "Hide Images": "Ukryj Obrazy",
        "Skip to accessibility menu": "Przejdź do menu dostępności",
        "Accessibility Report": "Raport Dostępności",
        "Run Accessibility Check": "Uruchom Sprawdzanie Dostępności",
        "Loading...": "Ładowanie...",
        "Analyzing page...": "Analizowanie strony...",
        "Critical": "Krytyczny",
        "Serious": "Poważny",
        "Moderate": "Umiarkowany",
        "Minor": "Drobny",
        "Violations Found": "Znalezione Naruszenia",
        "No Issues Found": "Brak Problemów",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Jak Naprawić",
        "Close Report": "Zamknij Raport",
        "Passed Tests": "Zaliczone Testy",
        "Items Need Review": "Elementy do Sprawdzenia",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Czytanie Tekstu Włączone",
        "Text to Speech Off": "Czytanie Tekstu Wyłączone",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Mowa",
        "Text": "Tekst",
        "Color & Contrast": "Kolor i Kontrast",
        "Reading Aids": "Pomoce do Czytania",
        "Interaction": "Interakcja",
        "Contrast": "Kontrast",
        "Saturation": "Saturacja",
        "Light": "Jasny",
        "Dark": "Ciemny",
        "High": "Wysoka",
        "Low": "Niska",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Ładowanie głosu...",
        "Reading...": "Reading...",
        "Profiles": "Profile",
        "Seizure Safe": "Bezpieczny dla Epileptyków",
        "Vision Impaired": "Dla Słabowidzących",
        "ADHD Friendly": "Przyjazny dla ADHD",
        "Dyslexia Friendly": "Przyjazny dla Dysleksji",
        "On": "Włączone",
        "Off": "Wyłączone",
        "Mute Sounds": "Wycisz Dźwięki",
        "Page Structure": "Struktura Strony",
        "Text Magnifier": "Lupa Tekstu",
        "Headings": "Nagłówki",
        "Landmarks": "Punkty Orientacyjne",
        "Links": "Linki",
        "No items found": "Nie znaleziono elementów",
        "Settings reset": "Ustawienia zresetowane",
      },
      ro: {
        "Accessibility": "Accesibilitate",
        "Accessibility Options": "Opțiuni de accesibilitate",
        "Accessibility Menu": "Meniu Accesibilitate",
        "Reset settings": "Resetare setări",
        "Reset All Settings": "Resetare toate setările",
        "Close": "Închide",
        "Content Adjustments": "Ajustări Conținut",
        "Adjust Font Size": "Ajustare Dimensiune Font",
        "Highlight Title": "Evidențiere Titluri",
        "Highlight Links": "Evidențiere Linkuri",
        "Readable Font": "Font Lizibil",
        "Color Adjustments": "Ajustări Culoare",
        "Invert Colors": "Inversare Culori",
        "Light Contrast": "Contrast Luminos",
        "Dark Contrast": "Contrast Întunecat",
        "High Contrast": "Contrast Ridicat",
        "High Saturation": "Saturație Ridicată",
        "Low Saturation": "Saturație Scăzută",
        "Monochrome": "Monocrom",
        "Tools": "Instrumente",
        "Reading Guide": "Ghid de Citire",
        "Stop Animations": "Oprire Animații",
        "Big Cursor": "Cursor Mare",
        "Increase Font Size": "Mărire Dimensiune Font",
        "Decrease Font Size": "Micșorare Dimensiune Font",
        "Letter Spacing": "Spațiere Litere",
        "Line Height": "Înălțime Linie",
        "Font Weight": "Grosime Font",
        "Dyslexia Font": "Font pentru Dislexie",
        "Font Size": "Dimensiune Font",
        "Language": "Limbă",
        "All Languages": "Toate Limbile",
        "Search language": "Căutare limbă",
        "Open Accessibility Menu": "Deschide Meniul Accesibilitate",
        "Open accessibility menu": "Deschide meniul de accesibilitate",
        "Hide Images": "Ascunde Imagini",
        "Skip to accessibility menu": "Salt la meniul de accesibilitate",
        "Accessibility Report": "Raport Accesibilitate",
        "Run Accessibility Check": "Rulează Verificare Accesibilitate",
        "Loading...": "Se încarcă...",
        "Analyzing page...": "Se analizează pagina...",
        "Critical": "Critic",
        "Serious": "Grav",
        "Moderate": "Moderat",
        "Minor": "Minor",
        "Violations Found": "Încălcări Găsite",
        "No Issues Found": "Nicio Problemă Găsită",
        "Element": "Element",
        "Issue": "Problemă",
        "How to Fix": "Cum se Remediază",
        "Close Report": "Închide Raportul",
        "Passed Tests": "Teste Trecute",
        "Items Need Review": "Elemente de Verificat",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Text to Speech Pornit",
        "Text to Speech Off": "Text to Speech Oprit",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voce",
        "Text": "Text",
        "Color & Contrast": "Culoare și Contrast",
        "Reading Aids": "Ajutoare de Citire",
        "Interaction": "Interacțiune",
        "Contrast": "Contrast",
        "Saturation": "Saturație",
        "Light": "Luminos",
        "Dark": "Întunecat",
        "High": "Ridicată",
        "Low": "Scăzută",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Se încarcă vocea...",
        "Reading...": "Reading...",
        "Profiles": "Profiluri",
        "Seizure Safe": "Protecție Epilepsie",
        "Vision Impaired": "Deficiențe de Vedere",
        "ADHD Friendly": "Adaptat pentru ADHD",
        "Dyslexia Friendly": "Adaptat pentru Dislexie",
        "On": "Activat",
        "Off": "Dezactivat",
        "Mute Sounds": "Dezactivare Sunete",
        "Page Structure": "Structura Paginii",
        "Text Magnifier": "Lupă pentru Text",
        "Headings": "Titluri",
        "Landmarks": "Repere",
        "Links": "Linkuri",
        "No items found": "Niciun element găsit",
        "Settings reset": "Setări resetate",
      },
      nl: {
        "Accessibility": "Toegankelijkheid",
        "Accessibility Options": "Toegankelijkheidsopties",
        "Accessibility Menu": "Toegankelijkheidsmenu",
        "Reset settings": "Instellingen resetten",
        "Reset All Settings": "Alle instellingen resetten",
        "Close": "Sluiten",
        "Content Adjustments": "Inhoudsaanpassingen",
        "Adjust Font Size": "Lettergrootte aanpassen",
        "Highlight Title": "Titels markeren",
        "Highlight Links": "Links markeren",
        "Readable Font": "Leesbaar Lettertype",
        "Color Adjustments": "Kleuraanpassingen",
        "Invert Colors": "Kleuren omkeren",
        "Light Contrast": "Licht Contrast",
        "Dark Contrast": "Donker Contrast",
        "High Contrast": "Hoog Contrast",
        "High Saturation": "Hoge Verzadiging",
        "Low Saturation": "Lage Verzadiging",
        "Monochrome": "Monochroom",
        "Tools": "Hulpmiddelen",
        "Reading Guide": "Leeshulp",
        "Stop Animations": "Animaties stoppen",
        "Big Cursor": "Grote Cursor",
        "Increase Font Size": "Lettergrootte vergroten",
        "Decrease Font Size": "Lettergrootte verkleinen",
        "Letter Spacing": "Letterafstand",
        "Line Height": "Regelhoogte",
        "Font Weight": "Letterdikte",
        "Dyslexia Font": "Dyslexie Lettertype",
        "Font Size": "Lettergrootte",
        "Language": "Taal",
        "All Languages": "Alle Talen",
        "Search language": "Taal zoeken",
        "Open Accessibility Menu": "Toegankelijkheidsmenu openen",
        "Open accessibility menu": "Toegankelijkheidsmenu openen",
        "Hide Images": "Afbeeldingen verbergen",
        "Skip to accessibility menu": "Ga naar toegankelijkheidsmenu",
        "Accessibility Report": "Toegankelijkheidsrapport",
        "Run Accessibility Check": "Toegankelijkheidscontrole uitvoeren",
        "Loading...": "Laden...",
        "Analyzing page...": "Pagina analyseren...",
        "Critical": "Kritiek",
        "Serious": "Ernstig",
        "Moderate": "Matig",
        "Minor": "Gering",
        "Violations Found": "Overtredingen Gevonden",
        "No Issues Found": "Geen Problemen Gevonden",
        "Element": "Element",
        "Issue": "Probleem",
        "How to Fix": "Hoe op te lossen",
        "Close Report": "Rapport Sluiten",
        "Passed Tests": "Geslaagde Tests",
        "Items Need Review": "Items te Controleren",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Tekst naar Spraak Aan",
        "Text to Speech Off": "Tekst naar Spraak Uit",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Spraak",
        "Text": "Tekst",
        "Color & Contrast": "Kleur & Contrast",
        "Reading Aids": "Leeshulpmiddelen",
        "Interaction": "Interactie",
        "Contrast": "Contrast",
        "Saturation": "Verzadiging",
        "Light": "Licht",
        "Dark": "Donker",
        "High": "Hoog",
        "Low": "Laag",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Stem laden...",
        "Reading...": "Reading...",
        "Profiles": "Profielen",
        "Seizure Safe": "Epilepsieveilig",
        "Vision Impaired": "Slechtziend",
        "ADHD Friendly": "ADHD-vriendelijk",
        "Dyslexia Friendly": "Dyslexievriendelijk",
        "On": "Aan",
        "Off": "Uit",
        "Mute Sounds": "Geluiden dempen",
        "Page Structure": "Paginastructuur",
        "Text Magnifier": "Tekstvergrootglas",
        "Headings": "Koppen",
        "Landmarks": "Oriëntatiepunten",
        "Links": "Links",
        "No items found": "Geen items gevonden",
        "Settings reset": "Instellingen gereset",
      },
      uk: {
        "Accessibility": "Доступність",
        "Accessibility Options": "Параметри доступності",
        "Accessibility Menu": "Меню доступності",
        "Reset settings": "Скинути налаштування",
        "Reset All Settings": "Скинути всі налаштування",
        "Close": "Закрити",
        "Content Adjustments": "Налаштування контенту",
        "Adjust Font Size": "Змінити розмір шрифту",
        "Highlight Title": "Виділити заголовки",
        "Highlight Links": "Виділити посилання",
        "Readable Font": "Читабельний шрифт",
        "Color Adjustments": "Налаштування кольору",
        "Invert Colors": "Інвертувати кольори",
        "Light Contrast": "Світлий контраст",
        "Dark Contrast": "Темний контраст",
        "High Contrast": "Високий контраст",
        "High Saturation": "Висока насиченість",
        "Low Saturation": "Низька насиченість",
        "Monochrome": "Монохромний",
        "Tools": "Інструменти",
        "Reading Guide": "Лінійка для читання",
        "Stop Animations": "Зупинити анімації",
        "Big Cursor": "Великий курсор",
        "Increase Font Size": "Збільшити розмір шрифту",
        "Decrease Font Size": "Зменшити розмір шрифту",
        "Letter Spacing": "Міжлітерний інтервал",
        "Line Height": "Висота рядка",
        "Font Weight": "Жирний шрифт",
        "Dyslexia Font": "Шрифт для дислексії",
        "Font Size": "Розмір шрифту",
        "Language": "Мова",
        "All Languages": "Усі мови",
        "Search language": "Пошук мови",
        "Open Accessibility Menu": "Відкрити меню доступності",
        "Open accessibility menu": "Відкрити меню доступності",
        "Hide Images": "Приховати зображення",
        "Skip to accessibility menu": "Перейти до меню доступності",
        "Accessibility Report": "Звіт про доступність",
        "Run Accessibility Check": "Запустити перевірку доступності",
        "Loading...": "Завантаження...",
        "Analyzing page...": "Аналіз сторінки...",
        "Critical": "Критичний",
        "Serious": "Серйозний",
        "Moderate": "Помірний",
        "Minor": "Незначний",
        "Violations Found": "Знайдені порушення",
        "No Issues Found": "Проблем не знайдено",
        "Element": "Елемент",
        "Issue": "Проблема",
        "How to Fix": "Як виправити",
        "Close Report": "Закрити звіт",
        "Passed Tests": "Пройдені тести",
        "Items Need Review": "Потребують перевірки",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Озвучування Увімкнено",
        "Text to Speech Off": "Озвучування Вимкнено",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Мовлення",
        "Text": "Текст",
        "Color & Contrast": "Колір і контраст",
        "Reading Aids": "Допомога при читанні",
        "Interaction": "Взаємодія",
        "Contrast": "Контраст",
        "Saturation": "Насиченість",
        "Light": "Світлий",
        "Dark": "Темний",
        "High": "Висока",
        "Low": "Низька",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Завантаження голосу...",
        "Reading...": "Reading...",
        "Profiles": "Профілі",
        "Seizure Safe": "Захист від епілепсії",
        "Vision Impaired": "Для людей з вадами зору",
        "ADHD Friendly": "Для людей з РДУГ",
        "Dyslexia Friendly": "Для людей з дислексією",
        "On": "Увімкнено",
        "Off": "Вимкнено",
        "Mute Sounds": "Вимкнути звук",
        "Page Structure": "Структура сторінки",
        "Text Magnifier": "Текстова лупа",
        "Headings": "Заголовки",
        "Landmarks": "Орієнтири",
        "Links": "Посилання",
        "No items found": "Нічого не знайдено",
        "Settings reset": "Налаштування скинуто",
      },
      ar: {
        "Accessibility": "إمكانية الوصول",
        "Accessibility Options": "خيارات إمكانية الوصول",
        "Accessibility Menu": "قائمة إمكانية الوصول",
        "Reset settings": "إعادة تعيين الإعدادات",
        "Reset All Settings": "إعادة تعيين جميع الإعدادات",
        "Close": "إغلاق",
        "Content Adjustments": "تعديلات المحتوى",
        "Adjust Font Size": "تعديل حجم الخط",
        "Highlight Title": "تمييز العناوين",
        "Highlight Links": "تمييز الروابط",
        "Readable Font": "خط سهل القراءة",
        "Color Adjustments": "تعديلات الألوان",
        "Invert Colors": "عكس الألوان",
        "Light Contrast": "تباين فاتح",
        "Dark Contrast": "تباين داكن",
        "High Contrast": "تباين عالٍ",
        "High Saturation": "تشبع عالٍ",
        "Low Saturation": "تشبع منخفض",
        "Monochrome": "أحادي اللون",
        "Tools": "أدوات",
        "Reading Guide": "دليل القراءة",
        "Stop Animations": "إيقاف الرسوم المتحركة",
        "Big Cursor": "مؤشر كبير",
        "Increase Font Size": "تكبير حجم الخط",
        "Decrease Font Size": "تصغير حجم الخط",
        "Letter Spacing": "تباعد الأحرف",
        "Line Height": "ارتفاع السطر",
        "Font Weight": "سُمك الخط",
        "Dyslexia Font": "خط لعُسر القراءة",
        "Font Size": "حجم الخط",
        "Language": "اللغة",
        "All Languages": "جميع اللغات",
        "Search language": "البحث عن لغة",
        "Open Accessibility Menu": "فتح قائمة إمكانية الوصول",
        "Open accessibility menu": "فتح قائمة إمكانية الوصول",
        "Hide Images": "إخفاء الصور",
        "Skip to accessibility menu": "الانتقال إلى قائمة إمكانية الوصول",
        "Accessibility Report": "تقرير إمكانية الوصول",
        "Run Accessibility Check": "تشغيل فحص إمكانية الوصول",
        "Loading...": "جارٍ التحميل...",
        "Analyzing page...": "جارٍ تحليل الصفحة...",
        "Critical": "حرج",
        "Serious": "خطير",
        "Moderate": "متوسط",
        "Minor": "طفيف",
        "Violations Found": "المخالفات المكتشفة",
        "No Issues Found": "لم يتم العثور على مشاكل",
        "Element": "العنصر",
        "Issue": "المشكلة",
        "How to Fix": "كيفية الإصلاح",
        "Close Report": "إغلاق التقرير",
        "Passed Tests": "الاختبارات الناجحة",
        "Items Need Review": "عناصر تحتاج إلى مراجعة",
        "Annotations": "التعليقات التوضيحية",
        "Text to Speech": "تحويل النص إلى كلام",
        "Text to Speech On": "تحويل النص إلى كلام مفعّل",
        "Text to Speech Off": "تحويل النص إلى كلام معطّل",
        "Simplify Layout": "تبسيط التخطيط",
        "Speech": "الكلام",
        "Text": "النص",
        "Color & Contrast": "اللون والتباين",
        "Reading Aids": "مساعدات القراءة",
        "Interaction": "التفاعل",
        "Contrast": "التباين",
        "Saturation": "التشبع",
        "Light": "فاتح",
        "Dark": "داكن",
        "High": "عالٍ",
        "Low": "منخفض",
        "Play": "تشغيل",
        "Pause": "إيقاف مؤقت",
        "Stop": "إيقاف",
        "Loading voice...": "جارٍ تحميل الصوت...",
        "Reading...": "جارٍ القراءة...",
        "Profiles": "الملفات الشخصية",
        "Seizure Safe": "آمن لمرضى الصرع",
        "Vision Impaired": "لضعاف البصر",
        "ADHD Friendly": "مناسب لفرط الحركة وتشتت الانتباه",
        "Dyslexia Friendly": "مناسب لعُسر القراءة",
        "On": "مفعّل",
        "Off": "معطّل",
        "Mute Sounds": "كتم الأصوات",
        "Page Structure": "بنية الصفحة",
        "Text Magnifier": "مكبّر النص",
        "Headings": "العناوين",
        "Landmarks": "المعالم",
        "Links": "الروابط",
        "No items found": "لم يتم العثور على عناصر",
        "Settings reset": "تمت إعادة تعيين الإعدادات",
      },
      he: {
        "Accessibility": "נגישות",
        "Accessibility Options": "אפשרויות נגישות",
        "Accessibility Menu": "תפריט נגישות",
        "Reset settings": "איפוס הגדרות",
        "Reset All Settings": "איפוס כל ההגדרות",
        "Close": "סגירה",
        "Content Adjustments": "התאמות תוכן",
        "Adjust Font Size": "התאמת גודל גופן",
        "Highlight Title": "הדגשת כותרות",
        "Highlight Links": "הדגשת קישורים",
        "Readable Font": "גופן קריא",
        "Color Adjustments": "התאמות צבע",
        "Invert Colors": "היפוך צבעים",
        "Light Contrast": "ניגודיות בהירה",
        "Dark Contrast": "ניגודיות כהה",
        "High Contrast": "ניגודיות גבוהה",
        "High Saturation": "רוויה גבוהה",
        "Low Saturation": "רוויה נמוכה",
        "Monochrome": "מונוכרום",
        "Tools": "כלים",
        "Reading Guide": "סרגל קריאה",
        "Stop Animations": "עצירת אנימציות",
        "Big Cursor": "סמן גדול",
        "Increase Font Size": "הגדלת גודל גופן",
        "Decrease Font Size": "הקטנת גודל גופן",
        "Letter Spacing": "ריווח אותיות",
        "Line Height": "גובה שורה",
        "Font Weight": "עובי גופן",
        "Dyslexia Font": "גופן מותאם לדיסלקציה",
        "Font Size": "גודל גופן",
        "Language": "שפה",
        "All Languages": "כל השפות",
        "Search language": "חיפוש שפה",
        "Open Accessibility Menu": "פתיחת תפריט נגישות",
        "Open accessibility menu": "פתיחת תפריט נגישות",
        "Hide Images": "הסתרת תמונות",
        "Skip to accessibility menu": "דילוג לתפריט הנגישות",
        "Accessibility Report": "דוח נגישות",
        "Run Accessibility Check": "הפעלת בדיקת נגישות",
        "Loading...": "טוען...",
        "Analyzing page...": "מנתח את הדף...",
        "Critical": "קריטי",
        "Serious": "חמור",
        "Moderate": "בינוני",
        "Minor": "קל",
        "Violations Found": "הפרות שנמצאו",
        "No Issues Found": "לא נמצאו בעיות",
        "Element": "רכיב",
        "Issue": "בעיה",
        "How to Fix": "כיצד לתקן",
        "Close Report": "סגירת הדוח",
        "Passed Tests": "בדיקות שעברו",
        "Items Need Review": "פריטים הדורשים בדיקה",
        "Annotations": "הערות",
        "Text to Speech": "הקראת טקסט",
        "Text to Speech On": "הקראת טקסט פועלת",
        "Text to Speech Off": "הקראת טקסט כבויה",
        "Simplify Layout": "פישוט הפריסה",
        "Speech": "דיבור",
        "Text": "טקסט",
        "Color & Contrast": "צבע וניגודיות",
        "Reading Aids": "עזרי קריאה",
        "Interaction": "אינטראקציה",
        "Contrast": "ניגודיות",
        "Saturation": "רוויה",
        "Light": "בהיר",
        "Dark": "כהה",
        "High": "גבוהה",
        "Low": "נמוכה",
        "Play": "נגן",
        "Pause": "השהה",
        "Stop": "עצור",
        "Loading voice...": "טוען קול...",
        "Reading...": "מקריא...",
        "Profiles": "פרופילים",
        "Seizure Safe": "מותאם לאפילפסיה",
        "Vision Impaired": "מותאם ללקויי ראייה",
        "ADHD Friendly": "מותאם להפרעות קשב",
        "Dyslexia Friendly": "מותאם לדיסלקציה",
        "On": "מופעל",
        "Off": "כבוי",
        "Mute Sounds": "השתקת צלילים",
        "Page Structure": "מבנה הדף",
        "Text Magnifier": "זכוכית מגדלת לטקסט",
        "Headings": "כותרות",
        "Landmarks": "ציוני דרך",
        "Links": "קישורים",
        "No items found": "לא נמצאו פריטים",
        "Settings reset": "ההגדרות אופסו",
      }
    };

export const SUPPORTED_LANGUAGES = [
      { code: "en", label: "English (English)" },
      { code: "pt", label: "Português (Portuguese)" },
      { code: "it", label: "Italiano (Italian)" },
      { code: "fr", label: "Français (French)" },
      { code: "de", label: "Deutsch (German)" },
      { code: "es", label: "Español (Spanish)" },
      { code: "ru", label: "Русский (Russian)" },
      { code: "pl", label: "Polski (Polish)" },
      { code: "ro", label: "Română (Romanian)" },
      { code: "nl", label: "Nederlands (Dutch)" },
      { code: "uk", label: "Українська (Ukrainian)" },
      { code: "ar", label: "العربية (Arabic)" },
      { code: "he", label: "עברית (Hebrew)" }
    ];
